import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import AuthActionCard from "../AuthActionCard/AuthActionCard";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import { postCall } from "../../../Api/axios";
import { useFormik } from "formik";
import * as Yup from "yup";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "2px !important",
    height: "35px !important",
    "& fieldset": {
      borderColor: "d9d9d9",
    },
    "&:hover fieldset": {
      borderColor: "#1890ff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1890ff",
    },
  },
});

const ForgotPassword = () => {
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    }),
    onSubmit: async (values, { setStatus }) => {
      const url = `/api/v2/dashboard/forgotPassword`;
      try {
        await postCall(url, { email: values.email });
        setStatus({ success: true, message: 'OTP sent to your email' });
      } catch (error) {
        setStatus({ success: false, message: error?.response?.data?.message || 'Something went wrong' });
      }
    },
  });

  const forgot_password_form = (
    <div className="m-auto w-10/12 md:w-3/4">
      <form onSubmit={formik.handleSubmit}>
        <div className="py-1">
          <label
            htmlFor="email"
            className="text-sm py-2 ml-1 font-medium text-left text-[#606161] inline-block"
          >
            Email
            <span className="text-[#FF0000]"> *</span>
          </label>
          <CssTextField
            required
            size="small"
            name="email"
            type="email"
            placeholder="Enter Email"
            autoComplete="off"
            className="w-full h-full px-2.5 py-3.5 text-[#606161] bg-transparent !border-black"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </div>

        {/* Success or Error Message */}
        {formik.status?.message && (
          <p
            className={`text-xs mt-2 ${
              formik.status.success ? "text-green-600" : "text-red-600"
            }`}
          >
            {formik.status.message}
          </p>
        )}

        <br />

        <Button
          type="submit"
          variant="contained"
          sx={{ backgroundColor: "#1890ff" }}
          disabled={!formik.isValid || formik.isSubmitting}
        >
          Get OTP
        </Button>
      </form>
    </div>
  );

  const navigation_link = (
    <div className="py-2 text-center">
      <p className="text-xs text-[#606161]">Already have an account?</p>
      <NavLink to="/login">
        <p className="text-xs text-[#3d629ad2] hover:text-[#0066ffd2]">Login</p>
      </NavLink>
    </div>
  );

  return (
    <AuthActionCard
      action_form={forgot_password_form}
      navigation_link={navigation_link}
    />
  );
};

export default ForgotPassword;